let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gSkqq")).then(() => parcelRequire('aueTu'));